import axios from "axios";
import { useContext, useEffect, useState } from 'react';
import { Badge, Button, Card, Col, Modal, Row, Table } from 'react-bootstrap';
import {
  ArrowUpCircle,
  CarFront,
  CheckCircle, ClockHistory,
  Eye, FileEarmarkImage,
  GraphUpArrow,
  XCircle
} from 'react-bootstrap-icons';
import '../../../assets/css/Admin/Earnings/Earnings.css';
import AppContext from "../../../context/AppContext";
import AdminMasterLayout from '../../../layouts/Admin/AdminMasterLayout';

const Earnings = () => {
  const { baseUrl, baseUrlforfile } = useContext(AppContext);
  const authToken = localStorage.getItem("authToken");
  const [TopupRequests, setTopupRequests] = useState([]);
  const [activeFilter, setActiveFilter] = useState('Pending');
  const [showDetailModal, setShowDetailModal] = useState(false);
  const [showProofModal, setShowProofModal] = useState(false);
  const [selected, setSelected] = useState(null);
  const [loading, setLoading] = useState(true);

  const companyStats = {
    totalRevenue: 110000,
    totalProfit: 6250,      // 5% Admin Net Profit
    totalRides: 50,
  };

  const totalPending = TopupRequests.filter(r => r.status === 'Pending').length;
  const totalApproved = TopupRequests.filter(r => r.status === 'Approved').length;
  const totalRejected = TopupRequests.filter(r => r.status === 'Rejected').length;

  const filtered = TopupRequests.filter(r => r.status === activeFilter);

  useEffect(() => {
    axios.get(`${baseUrl}/admin/topup/viewTopupRequests`, {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }).then((response) => {
      console.log("Topup Requests:", response.data);

      if (response.data.success === true) {

        setTopupRequests(response.data.topup);
        setLoading(false);
      }
    }).catch((error) => {
      console.log(error);
      alert("Network Error! Please try again.");
    });
  }, []);
  // approve
  const handleApprove = (id) => {
    axios.post(`${baseUrl}/admin/topup/approveTopup`, { id }, {
      headers: { Authorization: `Bearer ${authToken}` },
    }).then((response) => {
      if (response.data.success === true) {
        setTopupRequests(p => p.map(r => r.id === id ? { ...r, status: 'Approved' } : r));
      }
    }).catch((error) => {
      console.log(error);
      alert("Network Error! Please try again.");
    });
  };

  // reject 
  const handleReject = (id) => {
    axios.post(`${baseUrl}/admin/topup/rejectTopup`, { id }, {
      headers: { Authorization: `Bearer ${authToken}` },
    }).then((response) => {
      if (response.data.success === true) {
        setTopupRequests(p => p.map(r => r.id === id ? { ...r, status: 'Rejected' } : r));
      }
    }).catch((error) => {
      console.log(error);
      alert("Network Error! Please try again.");
    });
  };

  const statusColor = (s) => s === 'Approved' ? 'success' : s === 'Rejected' ? 'danger' : 'warning';

  return (
    <AdminMasterLayout>
      <div className="earnings-container">

        {/* ── Header ── */}
        <div className="earnings-header">
          <div>
            <h2 className="earnings-title">Driver Top-up Requests</h2>
            <p className="earnings-subtitle">Verify bank transfer proofs and manage coin top-up TopupRequests</p>
          </div>
        </div>

        {/* ── Company Earnings Stats ── */}
        <div className="earnings-section-label">
          <h5>Company Earnings Overview</h5>
        </div>
        <Row className="earnings-company-row">
          <Col md={3} sm={6} className="mb-3">
            <Card className="earnings-company-card earnings-cc-revenue h-100">
              <Card.Body>
                <div className="earnings-cc-icon"><GraphUpArrow size={22} /></div>
                <div>
                  <p className="earnings-cc-label">Total Revenue</p>
                  <h4 className="earnings-cc-value">PKR {companyStats.totalRevenue.toLocaleString()}</h4>
                  <span className="earnings-cc-sub">All time earnings</span>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3} sm={6} className="mb-3">
            <Card className="earnings-company-card earnings-cc-profit h-100">
              <Card.Body>
                <div className="earnings-cc-icon"><ArrowUpCircle size={22} /></div>
                <div>
                  <p className="earnings-cc-label">Admin Net Profit</p>
                  <h4 className="earnings-cc-value">PKR {companyStats.totalProfit.toLocaleString()}</h4>
                  <span className="earnings-cc-sub">5% (Platform share after payouts)</span>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3} sm={6} className="mb-3">
            <Card className="earnings-company-card earnings-cc-rides h-100">
              <Card.Body>
                <div className="earnings-cc-icon"><CarFront size={22} /></div>
                <div>
                  <p className="earnings-cc-label">Total Rides</p>
                  <h4 className="earnings-cc-value">{companyStats.totalRides}</h4>
                  <span className="earnings-cc-sub">Completed rides</span>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* ── Topup Request Stats ── */}
        <div className="earnings-section-label">
          <h5>Top-up Request Summary</h5>
        </div>
        <Row className="earnings-req-row">
          <Col md={3} sm={6} className="mb-3">
            <Card className="earnings-req-card earnings-req-pending h-100">
              <Card.Body>
                <div className="earnings-req-icon"><ClockHistory size={20} /></div>
                <div>
                  <p className="earnings-req-label">Pending</p>
                  <h4 className="earnings-req-value">{totalPending}</h4>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3} sm={6} className="mb-3">
            <Card className="earnings-req-card earnings-req-approved h-100">
              <Card.Body>
                <div className="earnings-req-icon"><CheckCircle size={20} /></div>
                <div>
                  <p className="earnings-req-label">Approved</p>
                  <h4 className="earnings-req-value">{totalApproved}</h4>
                </div>
              </Card.Body>
            </Card>
          </Col>
          <Col md={3} sm={6} className="mb-3">
            <Card className="earnings-req-card earnings-req-rejected h-100">
              <Card.Body>
                <div className="earnings-req-icon"><XCircle size={20} /></div>
                <div>
                  <p className="earnings-req-label">Rejected</p>
                  <h4 className="earnings-req-value">{totalRejected}</h4>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* ── Filter Tabs ── */}
        <div className="earnings-filter-row">
          {['Pending', 'Approved', 'Rejected'].map(f => (
            <button
              key={f}
              className={`earnings-filter-btn ${activeFilter === f ? 'earnings-filter-active' : ''}`}
              onClick={() => setActiveFilter(f)}
            >
              {f}
              <span className="earnings-filter-count">
                {f === 'All' ? TopupRequests.length : TopupRequests.filter(r => r.status === f).length}
              </span>
            </button>
          ))}
        </div>

        {/* ── Table ── */}
        <Row className="earnings-table-row">
          <Col>
            <Card className="earnings-table-card">
              <Card.Header className="earnings-table-header">
                <h5 className="earnings-table-title">Top-up TopupRequests</h5>
              </Card.Header>
              <Card.Body className="p-0">
                <div className="earnings-table-wrapper">
                  <Table hover responsive className="earnings-table">
                    <thead>
                      <tr>
                        <th>Top-up ID</th>
                        <th>Driver Name</th>
                        <th>Driver ID</th>
                        <th>Amount (PKR)</th>
                        <th>Date & Time</th>
                        <th>Status</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                    <tbody>
                      {loading ? (
                        <tr>
                          <td colSpan={9} className="text-center py-4">Loading...</td>
                        </tr>
                      ) : filtered.length === 0 ? (
                        <tr>
                          <td colSpan={9} className="earnings-empty">No TopupRequests found</td>
                        </tr>
                      ) : filtered.map(req => (
                        <tr key={req.id}>
                          <td className="earnings-td-id">{req.id}</td>
                          <td className="earnings-td-name">{req.tddriver?.drivername ?? 'Unknown'}</td>
                          <td>{req.tddriver_id}</td>
                          <td className="earnings-td-amount">PKR {req.amount.toLocaleString()}</td>
                          <td>
                            <div className="earnings-td-dt">
                              <span className="earnings-td-date">{new Date(req.created_at).toLocaleDateString()}</span>
                              <span className="earnings-td-time">{new Date(req.created_at).toLocaleTimeString()}
                              </span>
                            </div>
                          </td>
                          <td><Badge bg={statusColor(req.status)}>{req.status}</Badge></td>
                          <td>
                            <div className="earnings-action-wrap">
                              <Button className="earnings-btn-detail" size="sm" onClick={() => { setSelected(req); setShowDetailModal(true); }}>
                                <Eye size={13} /> Detail
                              </Button>
                              <Button className="earnings-btn-proof" size="sm" onClick={() => { setSelected(req); setShowProofModal(true); }}>
                                <FileEarmarkImage size={13} /> Proof
                              </Button>
                              {req.status === 'Pending' && <>
                                <Button className="earnings-btn-approve" size="sm" onClick={() => handleApprove(req.id)}>
                                  <CheckCircle size={13} /> Approve
                                </Button>
                                <Button className="earnings-btn-reject" size="sm" onClick={() => handleReject(req.id)}>
                                  <XCircle size={13} /> Reject
                                </Button>
                              </>}
                            </div>
                          </td>
                        </tr>
                      ))}
                    </tbody>
                  </Table>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        {/* ── Detail Modal ── */}
        <Modal show={showDetailModal} onHide={() => setShowDetailModal(false)} centered>
          <Modal.Header closeButton className="earnings-modal-header">
            <Modal.Title>Top-up Detail</Modal.Title>
          </Modal.Header>
          <Modal.Body className="earnings-modal-body">
            {selected && <>
              {[
                ['Top-up ID', selected.id],
                ['Driver Name', selected.tddriver?.drivername ?? 'Unknown'],
                ['Driver ID', selected.tddriver_id],
                ['Date & Time', new Date(selected.created_at).toLocaleString()],
              ].map(([k, v]) => (
                <div className="earnings-modal-row" key={k}>
                  <strong>{k}</strong><span>{v}</span>
                </div>
              ))}
              <div className="earnings-modal-row">
                <strong>Amount Paid</strong>
                <span className="earnings-modal-amount">PKR {selected.amount.toLocaleString()}</span>
              </div>
              <div className="earnings-modal-row">
                <strong>Status</strong>
                <Badge bg={statusColor(selected.status)}>{selected.status}</Badge>
              </div>
            </>}
          </Modal.Body>
          <Modal.Footer className="earnings-modal-footer">
            <Button className="earnings-btn-close" onClick={() => setShowDetailModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>

        {/* ── Proof Modal ── */}
        <Modal show={showProofModal} onHide={() => setShowProofModal(false)} centered>
          <Modal.Header closeButton className="earnings-modal-header">
            <Modal.Title>Transaction Proof</Modal.Title>
          </Modal.Header>
          <Modal.Body className="earnings-modal-body">
            {selected && <>
              <div className="earnings-modal-row"><strong>Driver</strong><span>{selected.tddriver?.drivername ?? 'Unknown'}</span></div>
              <div className="earnings-modal-row">
                <strong>Amount</strong>
                <span className="earnings-modal-amount">PKR {Number(selected.amount).toLocaleString()}</span>
              </div>
              <div className="earnings-proof-box">
                <p className="earnings-proof-label">Transaction Screenshot</p>
                <img
                  src={`${baseUrlforfile}/${selected.image}`}
                  alt="proof"
                  className="earnings-proof-img"
                  onError={(e) => console.log("IMG ERROR:", e.target.src)} // debug
                />
              </div>
            </>}
          </Modal.Body>
          <Modal.Footer className="earnings-modal-footer">
            <Button className="earnings-btn-close" onClick={() => setShowProofModal(false)}>Close</Button>
          </Modal.Footer>
        </Modal>

      </div>
    </AdminMasterLayout>
  );
};

export default Earnings;